import { buildQueryKey } from '@webapp/core/utils/react-query/buildQueryKey'
import { getInitialPOPDFLabelSet } from '../business-logic/use-cases/getInitialPOPDFLabelSet'
import { getPOPDFLabelEditorFields } from '../business-logic/use-cases/getPOPDFLabelEditorFields'

const base = ['po-pdf-label-editor']

/**
 * Use-Case-backed editor configs. `editorFields().queryKey` is also
 * invalidated by the PO custom-field command Models to keep the editor's
 * custom-field sub-sections fresh.
 */
export const poPdfLabelEditorQueryConfig = {
  initialSet: () => ({
    queryKey: buildQueryKey([...base, 'initial-set']),
    queryFn: () => getInitialPOPDFLabelSet(),
  }),
  editorFields: () => ({
    queryKey: buildQueryKey([...base, 'fields']),
    queryFn: () => getPOPDFLabelEditorFields(),
  }),
}
